import GoogleTagManagerService from "../services/tracking/GoogleTagManagerService";

export const updateTitle = (title, event) => {
  if (typeof window !== "undefined") {
    const newTitle = buildTitle(title, event);
    document.title = newTitle;
    return newTitle;
  }
};

export const buildTitle = (title, event) => {
  const titleParts = [];
  if (title) {
    titleParts.push(title);
  }
  if (event && event.data && event.data.name) {
    titleParts.push(event.data.name);
  }
  titleParts.push("Humanitix");
  return titleParts.join(" | ");
};

const customPageView = title => {
  if (typeof window !== "undefined") {
    GoogleTagManagerService.pageViewCustom(title);
  }
};

export const pageChange = (title, event) => {
  const newTitle = updateTitle(title, event);
  customPageView(newTitle);
};



// WEBPACK FOOTER //
// ./utils/BrowserUtils.js